// extracted by mini-css-extract-plugin
module.exports = {"root":"whatsAppChat-module--root--xoi65"};